import { connect } from 'react-redux'

import {
  selectIsUpdateAvailable,
  selectIsLeftSidebarCollapsed,
} from 'selectors/app'
import {
  selectCurrentTicketSearchQueryString,
  selectHasCurrentTicketSearchErrored,
  selectIsCurrentTicketSearchQueryValid,
} from 'selectors/search'
import { selectCurrentTicketId } from 'selectors/tickets'
import {
  selectIsTicketSelectionMode,
  selectTicketSelectionCount,
} from 'selectors/ticket_list'
import { selectShowDemoMailboxBar } from 'selectors/mailboxes'
import { selectAgentHasMailboxAccess } from 'selectors/mailboxes_base'
import { doHideLaunchBar } from 'actions/app'

import Layout from './view'

const select = state => {
  return {
    areTicketsSelected: selectTicketSelectionCount(state) > 0,
    hasMailboxAccess: selectAgentHasMailboxAccess(state),
    hasSearchErrored: selectHasCurrentTicketSearchErrored(state),
    isBulkSelectionMode: selectIsTicketSelectionMode(state),
    isQueryStringValid: selectIsCurrentTicketSearchQueryValid(state),
    isUpdateAvailable: selectIsUpdateAvailable(state),
    queryString: selectCurrentTicketSearchQueryString(state),
    queryStringIsComplete: true, // always true since we build it ourselves.
    showDemoMailboxBar: selectShowDemoMailboxBar(state),
    ticketId: selectCurrentTicketId(state),
    isLeftSidebarCollapsed: selectIsLeftSidebarCollapsed(state),
  }
}

const perform = {
  doHideLaunchBar,
}

export default connect(select, perform)(Layout)
